import classNames from 'classnames';
import React from 'react';

import { Box, Container, Grid } from '@material-ui/core';

import { Image } from '../components';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockImage } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  gridItem: {
    textAlign: ({ align }: Props['block']) => align ?? 'center',
  },
}));

type Props = BlockBuilder<BlockImage>;

export const ImageBlock: React.FC<Props> = ({ block, getImageData }) => {
  const { image, alt, size: blockSize, align } = block;
  const classes = useBlockStyles(useStyles, block);

  const size = blockSize ?? 'medium';
  const imgCols = size === 'large' ? 12 : size === 'medium' ? 9 : 6;
  const justify =
    align ?? 'center' === 'center'
      ? 'center'
      : align === 'left'
      ? 'flex-start'
      : 'flex-end';

  return (
    <Box className={classNames(classes.boxBlock, classes.gridShow)}>
      <Container>
        <Grid container justifyContent={justify}>
          <Grid item xs={12} md={imgCols} className={classes.gridItem}>
            <Image
              getImageData={getImageData}
              src={image}
              alt={alt || image}
              isBackground={false}
              options={{
                maxWidth: '100%',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
